'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var ExcelJS = require('exceljs');
var FileSaver = require('file-saver');
var Bowser = require('bowser');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var ExcelJS__namespace = /*#__PURE__*/_interopNamespace(ExcelJS);
var FileSaver__default = /*#__PURE__*/_interopDefaultLegacy(FileSaver);
var Bowser__default = /*#__PURE__*/_interopDefaultLegacy(Bowser);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function useDebounce(value, timeout) {
    if (timeout === void 0) { timeout = 2 * 1000; }
    var _a = __read(react.useState(value), 2), state = _a[0], setState = _a[1];
    react.useEffect(function () {
        var handler = setTimeout(function () { return setState(value); }, timeout);
        return function () { return clearTimeout(handler); };
    }, [value, timeout]);
    return state;
}

var useInterval = function (callback, delay) {
    var savedCallback = react.useRef(callback);
    react.useLayoutEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    react.useEffect(function () {
        if (!delay) {
            return undefined;
        }
        var id = setInterval(savedCallback.current, delay);
        return function () { return clearInterval(id); };
    }, [delay]);
};

var useOutsideClick = function (reference, onOutsideClick) {
    var handleClick = function (event) {
        var _a;
        if (!((_a = reference === null || reference === void 0 ? void 0 : reference.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
            onOutsideClick(event);
        }
    };
    react.useEffect(function () {
        document.addEventListener('click', handleClick);
        return function () {
            document.removeEventListener('click', handleClick);
        };
    });
};

var useThemeChange = function (_a) {
    var onThemeChange = _a.onThemeChange;
    react.useEffect(function () {
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'theme') {
                    onThemeChange(document.documentElement.getAttribute('theme'));
                }
            });
        });
        observer.observe(document.documentElement, { attributes: true });
    }, [onThemeChange]);
};

/**
 * Essa função é responsável por pesquisar se o Cookie com
 * o bearer do usuário está salvo no navegador
 * @param cname nome do cookie
 */
var getCookie = function (key) {
    var _a;
    if (typeof document !== 'undefined') {
        var decodedCookie = decodeURIComponent(document.cookie);
        return (((_a = decodedCookie
            .split(';')
            .find(function (item) { return item.split('=')[0].trim() === key; })) === null || _a === void 0 ? void 0 : _a.split('=')[1]) || '');
    }
    return '';
};
/**
 * Função que cria o cookie com o nome parametrizado
 */
var setCookie = function (_a) {
    var key = _a.key, value = _a.value, args = __rest(_a, ["key", "value"]);
    if (typeof document !== 'undefined') {
        var newCookie_1 = "".concat(key, "=").concat(value, ";");
        Object.entries(args).forEach(function (_a) {
            var _b = __read(_a, 2), argKey = _b[0], argValue = _b[1];
            if (argKey === 'expires') {
                newCookie_1 += "".concat(argKey, "=").concat(argValue.toUTCString(), ";");
                return;
            }
            newCookie_1 += "".concat(argKey, "=").concat(argValue, ";");
        });
        document.cookie = newCookie_1;
    }
};

var downloadObjectInCSVFormat = function (_a) {
    var headers = _a.headers, data = _a.data, fileName = _a.fileName, _b = _a.delimiter, delimiter = _b === void 0 ? ';' : _b;
    data.unshift(__assign({}, headers));
    var csvContent = data.map(function (row) { return Object.values(row).join(delimiter); }).join('\n');
    var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    var url = URL.createObjectURL(blob);
    var anchorElement = document.createElement('a');
    anchorElement.setAttribute('href', url);
    anchorElement.setAttribute('download', "".concat(fileName, ".csv"));
    anchorElement.style.visibility = 'hidden';
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
};

var exportXLSX = function (_a) {
    var headers = _a.headers, data = _a.data, fileName = _a.fileName;
    var workbook = new ExcelJS__namespace.Workbook();
    var worksheet = workbook.addWorksheet('Minha Planilha');
    worksheet.columns = headers;
    data.forEach(function (item) {
        worksheet.addRow(item);
    });
    workbook.xlsx.writeBuffer().then(function (item) {
        var blob = new Blob([item], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        FileSaver__default['default'].saveAs(blob, "".concat(fileName, ".xlsx"));
    });
};

var formatToMask = function (value, mask) {
    var maskLength = __spreadArray([], __read(mask.matchAll(/#/g))).length;
    if (maskLength !== value.length)
        return value;
    var i = 0;
    return mask.replace(/#/g, function () {
        i += 1;
        return value[i - 1];
    });
};
var cellphoneMask = function (cellphone) {
    return formatToMask(cellphone, '(##) #####-####');
};
var cpfMask$1 = function (cpf) { return formatToMask(cpf, '###.###.###-##'); };
var accountMask = function (account) {
    return "".concat(account.slice(0, -1), "-").concat(account.slice(-1));
};

var formatOnlyNumbers = function (_a) {
    var value = _a.value;
    return value.replace(/[^0-9]/g, '');
};
var capitalize = function (value) { return value.charAt(0).toUpperCase() + value.slice(1); };

var cpfMask = '###.###.###-##';
var cnpjMask = '##.###.###/####-##';
var obfuscatePositions = function (_a) {
    var value = _a.value, positions = _a.positions;
    return value
        .split('')
        .map(function (item, index) { return (positions.includes(index) ? '*' : item); })
        .join('');
};
var obfuscateCpfOrCnpj = function (_a) {
    var value = _a.value, shouldFormat = _a.shouldFormat;
    var onlyNumbers = formatOnlyNumbers({ value: value });
    var isCpf = onlyNumbers.length === 11;
    var isCnpj = onlyNumbers.length === 14;
    if (isCpf) {
        var obfuscated = obfuscatePositions({
            value: onlyNumbers,
            positions: [0, 1, 2, 9, 10],
        });
        return shouldFormat ? formatToMask(obfuscated, cpfMask) : obfuscated;
    }
    if (isCnpj) {
        var obfuscated = obfuscatePositions({
            value: onlyNumbers,
            positions: [0, 1, 12, 13],
        });
        return shouldFormat ? formatToMask(obfuscated, cnpjMask) : obfuscated;
    }
    return value;
};
var formatCpfOrCnpj = function (_a) {
    var value = _a.value;
    var onlyNumbers = formatOnlyNumbers({ value: value });
    var isCpf = onlyNumbers.length === 11;
    var isCnpj = onlyNumbers.length === 14;
    if (!isCpf && !isCnpj)
        return '';
    return formatToMask(onlyNumbers, isCpf ? cpfMask : cnpjMask);
};

var formatToBrazilianDate = function (date) {
    var day = "".concat(date.getDate()).padStart(2, '0');
    var month = "".concat(date.getMonth() + 1).padStart(2, '0');
    var year = date.getFullYear();
    return "".concat(day, "/").concat(month, "/").concat(year);
};

var delay = function (milliseconds) {
    return new Promise(function (resolve) { return setTimeout(resolve, milliseconds); });
};

var defaultOptions = {
    percentage: 1,
    fromStart: true,
};
var generateAsteriskString = function (length) {
    return Array.from(new Array(length)).fill('*').join('');
};
var replaceByAsterisk = function (value, options) {
    if (options === void 0) { options = defaultOptions; }
    var percentage = options.percentage, fromStart = options.fromStart;
    if (percentage <= 0)
        return value;
    if (percentage === 1 || percentage > 1)
        return value.replace(/[\s\S/]/g, '*');
    var numberOfCharsToBeObsfucated = Math.round(value.length * percentage);
    var asteristString = generateAsteriskString(numberOfCharsToBeObsfucated);
    if (!fromStart)
        return value.substring(0, value.length - numberOfCharsToBeObsfucated) + asteristString;
    return asteristString + value.substring(numberOfCharsToBeObsfucated, value.length);
};

var obfuscateEmail = function (email) {
    var _a = __read(email.split('@'), 2), account = _a[0], fullDomain = _a[1];
    var obfuscateAccount = account.substring(0, 4) + replaceByAsterisk(account.substring(4, account.length));
    var _b = __read(fullDomain.split('.')), domain = _b[0], rest = _b.slice(1);
    var obfuscateDomain = "".concat(replaceByAsterisk(domain), ".").concat(rest.join('.'));
    return "".concat(obfuscateAccount, "@").concat(obfuscateDomain);
};

var getOperatingSystem = function () {
    var os = Bowser__default['default'].parse(window.navigator.userAgent).os;
    if (!Object.keys(os).length)
        return '';
    if (os.name.toLocaleLowerCase() === 'macos')
        os.name = 'MacOS';
    return os.name;
};
var getBrowserName = function () {
    var bowserBrowser = Bowser__default['default'].parse(window.navigator.userAgent).browser;
    return "".concat(bowserBrowser.name, " ").concat(bowserBrowser.version);
};

var isInViewport = function (element) {
    var rect = element.getBoundingClientRect().toJSON();
    return __assign(__assign({}, rect), { inside: rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) });
};

var isMobile = function () {
    return typeof window !== 'undefined' &&
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

var formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
});
var formatToBRL = function (amount) { return formatter.format(amount); };
var formatBRLToNumber = function (amount) {
    return +amount.replace(/[\\R$.]+/g, '').replace(',', '.');
};
var formatMoneyToNumber = function (value) {
    var currencySymbol = value.replace(/[0-9-,/./]+/g, '').replace(/\s/g, '');
    var newValue = value.replace(/[^0-9-,]+/g, '');
    if (!currencySymbol && !/[,]/.test(value)) {
        return { currencySymbol: currencySymbol, value: +value };
    }
    return { currencySymbol: currencySymbol, value: +newValue.replace(',', '.') };
};
var formatNumberToMoney = function (currencySymbol, value) {
    var newValue = formatter.format(value);
    return newValue.replace('R$', currencySymbol.replace(/\s/g, ''));
};

var getRandomNumber = function (_a) {
    var min = _a.min, max = _a.max;
    return Math.floor(Math.random() * (max - min + 1) + min);
};

var pad = function (_a) {
    var value = _a.value, size = _a.size, fillWith = _a.fillWith;
    var filled = Array.from({ length: size }, function () { return fillWith; });
    filled.push.apply(filled, __spreadArray([], __read(value.toString().split(''))));
    return filled.slice(-size).join('');
};

var obfuscateTelephone = function (value) {
    var ddd = value.substr(0, 5);
    var _a = __read(value.substr(4, value.length).split('-'), 2), first = _a[0], second = _a[1];
    var final = second.substr(1, 3);
    return "".concat(ddd).concat(replaceByAsterisk(first.trim()), "-*").concat(final);
};

var urlParams = function (myObject) {
    return Object.entries(myObject)
        .map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
    })
        .join('&');
};

var DEFAULT_PASSWORD_RULES = [
    {
        description: 'De 8 a 20 dígitos.',
        isValid: function (password) { return hasRequiredLength(password); },
        errorMessage: 'A senha deve ter de 8 a 20 dígitos',
    },
    {
        description: 'Pelo menos 1 letra maiúscula.',
        isValid: function (password) { return hasCapitalLetter(password); },
        errorMessage: 'A senha deve ter pelo menos 1 letra maiúscula',
    },
    {
        description: 'Pelo menos 1 letra minúscula.',
        isValid: function (password) { return hasLowerCaseLetter(password); },
        errorMessage: 'A senha deve ter pelo menos 1 letra minúscula',
    },
    {
        description: 'Pelo menos 1 caractere especial. (ex: *, #, $)',
        isValid: function (password) { return hasSpecialLetter(password); },
        errorMessage: 'A senha deve ter pelo menos 1 caractere especial. (ex: *, #, $)',
    },
    {
        description: 'Pelo menos 1 número.',
        isValid: function (password) { return hasNumber(password); },
        errorMessage: 'A senha deve ter 1 número',
    },
    {
        description: 'Não ter caracteres sequênciais ou idênticos. (ex: 1234, aaaa)',
        isValid: function (password) {
            return hasRequiredLength(password) &&
                !hasSequentialChar(password) &&
                !hasSequentialRepeatedChar(password);
        },
        errorMessage: 'A senha não pode conter caracteres sequênciais ou idênticos. (ex: 1234, aaaa)',
    },
];

var DEFAULT_TEXT_MIN_LENGTH = 8;
var DEFAULT_TEXT_MAX_LENGTH = 20;
var DEFAUL_MAX_REPETITION_LENGTH = 3;
var DEFAUL_MAX_SEQUENCE_LENGTH = 2;
var INVALID_CHAR_CODE = -1;
var hasRequiredLength = function (text, options) {
    if (options === void 0) { options = {
        minLength: DEFAULT_TEXT_MIN_LENGTH,
        maxLength: DEFAULT_TEXT_MAX_LENGTH,
    }; }
    return text.length >= options.minLength && text.length <= options.maxLength;
};
var hasCapitalLetter = function (text) { return /\p{Lu}/gu.test(text); };
var hasLowerCaseLetter = function (text) { return /\p{Ll}/gu.test(text); };
var hasSpecialLetter = function (text) { return /[^a-zA-Z0-9]+/g.test(text); };
var hasNumber = function (text) { return /[0-9]/g.test(text); };
var isLetterOrNumber = function (text) { return /[a-zA-Z0-9]/.test(text); };
var hasSequentialChar = function (text, maxRepetitionLength) {
    if (maxRepetitionLength === void 0) { maxRepetitionLength = DEFAUL_MAX_SEQUENCE_LENGTH; }
    var textChars = text.split('');
    var textLength = text.length;
    var forwardSequenceCounter = 0;
    var backwardSequenceCounter = 0;
    var hasSequence = false;
    textChars.forEach(function (char, index) {
        var currentCharCode = char.charCodeAt(0);
        var hasNextChar = index + 1 < textLength;
        var nextCharCode = hasNextChar ? textChars[index + 1].charCodeAt(0) : INVALID_CHAR_CODE;
        var isForwardSequence = nextCharCode === currentCharCode + 1;
        var isBackwardSequence = nextCharCode === currentCharCode - 1;
        if (isLetterOrNumber(String.fromCharCode(currentCharCode)) && isForwardSequence) {
            forwardSequenceCounter += 1;
        }
        if (isLetterOrNumber(String.fromCharCode(currentCharCode)) && isBackwardSequence) {
            backwardSequenceCounter += 1;
        }
        if (forwardSequenceCounter > maxRepetitionLength) {
            hasSequence = true;
        }
        if (backwardSequenceCounter > maxRepetitionLength) {
            hasSequence = true;
        }
        if (!isForwardSequence && nextCharCode !== INVALID_CHAR_CODE) {
            forwardSequenceCounter = 0;
        }
        if (!isBackwardSequence && nextCharCode !== INVALID_CHAR_CODE) {
            backwardSequenceCounter = 0;
        }
    });
    return hasSequence;
};
var hasRepeatedChar = function (text) { return /([a-zA-Z0-9]).*?\1/g.test(text); };
var hasSequentialRepeatedChar = function (text, maxRepetitionLength) {
    if (maxRepetitionLength === void 0) { maxRepetitionLength = DEFAUL_MAX_REPETITION_LENGTH; }
    var hasSequentialRegex = new RegExp("(\\w)\\1{".concat(maxRepetitionLength, ",}"), 'g');
    return hasSequentialRegex.test(text);
};

var uuid = function () {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};

exports.DEFAULT_PASSWORD_RULES = DEFAULT_PASSWORD_RULES;
exports.DEFAULT_TEXT_MAX_LENGTH = DEFAULT_TEXT_MAX_LENGTH;
exports.DEFAULT_TEXT_MIN_LENGTH = DEFAULT_TEXT_MIN_LENGTH;
exports.DEFAUL_MAX_REPETITION_LENGTH = DEFAUL_MAX_REPETITION_LENGTH;
exports.DEFAUL_MAX_SEQUENCE_LENGTH = DEFAUL_MAX_SEQUENCE_LENGTH;
exports.INVALID_CHAR_CODE = INVALID_CHAR_CODE;
exports.accountMask = accountMask;
exports.capitalize = capitalize;
exports.cellphoneMask = cellphoneMask;
exports.cpfMask = cpfMask$1;
exports.delay = delay;
exports.downloadObjectInCSVFormat = downloadObjectInCSVFormat;
exports.exportXLSX = exportXLSX;
exports.formatBRLToNumber = formatBRLToNumber;
exports.formatCpfOrCnpj = formatCpfOrCnpj;
exports.formatMoneyToNumber = formatMoneyToNumber;
exports.formatNumberToMoney = formatNumberToMoney;
exports.formatOnlyNumbers = formatOnlyNumbers;
exports.formatToBRL = formatToBRL;
exports.formatToBrazilianDate = formatToBrazilianDate;
exports.formatToMask = formatToMask;
exports.generateAsteriskString = generateAsteriskString;
exports.getBrowserName = getBrowserName;
exports.getCookie = getCookie;
exports.getOperatingSystem = getOperatingSystem;
exports.getRandomNumber = getRandomNumber;
exports.hasCapitalLetter = hasCapitalLetter;
exports.hasLowerCaseLetter = hasLowerCaseLetter;
exports.hasNumber = hasNumber;
exports.hasRepeatedChar = hasRepeatedChar;
exports.hasRequiredLength = hasRequiredLength;
exports.hasSequentialChar = hasSequentialChar;
exports.hasSequentialRepeatedChar = hasSequentialRepeatedChar;
exports.hasSpecialLetter = hasSpecialLetter;
exports.isInViewport = isInViewport;
exports.isLetterOrNumber = isLetterOrNumber;
exports.isMobile = isMobile;
exports.obfuscateCpfOrCnpj = obfuscateCpfOrCnpj;
exports.obfuscateEmail = obfuscateEmail;
exports.obfuscateTelephone = obfuscateTelephone;
exports.pad = pad;
exports.replaceByAsterisk = replaceByAsterisk;
exports.setCookie = setCookie;
exports.urlParams = urlParams;
exports.useDebounce = useDebounce;
exports.useInterval = useInterval;
exports.useOutsideClick = useOutsideClick;
exports.useThemeChange = useThemeChange;
exports.uuid = uuid;
